import React from "react";
import { Divider } from "@mui/material";

export default function Module_1(props) {
    return (
        <>
            <div className="full-width bg-white py-3">
                <div className="m-auto mw-900">
                    <div className="container">
                        <Divider>
                            <h2 className="py-4 text-muted text-uppercase text-center fs-1">
                                We have{" "}
                                <span className="text-decoration-underline text-underline-offset">
                                    vision
                                </span>
                            </h2>
                        </Divider>

                        <p>
                            The DSSL customer experience goes far beyond
                            purchasing a product. It’s first and foremost about
                            working with people sharing in our vision for the
                            future of the lighting business, by cultivating
                            relationships and engaging in open, constructive
                            dialogue with stakeholders to always do better by
                            our customers.
                        </p>
                    </div>
                </div>
                <div
                    style={{ maxWidth: "1200px" }}
                    className="container px-4 py-4 m-auto"
                    id="featured-3"
                >
                    <div className="container">
                        <div className="row g-4 pb-4 row-cols-1 row-cols-lg-3">
                            <div className="feature col">
                                <h2 className="text-center fw-bold">
                                    Community Spirit
                                </h2>
                                <p>
                                    We support locally sourced manufacturing and
                                    customizing initiatives to ensure greater
                                    sustainability, while fostering superior
                                    product quality and reliability, as well as
                                    shorter lead times. In addition, we are a
                                    certified minority-owned business that meets
                                    MBE criteria for government projects.
                                </p>
                            </div>
                            <div className="feature col">
                                <h2 className="text-center fw-bold">
                                    Integrity
                                </h2>
                                <p>
                                    We are committed to conducting business
                                    ethically, fairly and transparently. Also,
                                    we believe in treating people equally and
                                    with respect, both in and out of the
                                    workplace. And we always make time for our
                                    customers, whether to guide them through
                                    product selection, acknowledge specific
                                    requirements or discuss an issue they may
                                    have.
                                </p>
                            </div>
                            <div className="feature col">
                                <h2 className="text-center fw-bold">
                                    Collaboration
                                </h2>
                                <p>
                                    We address challenges using a collaborative,
                                    solution-oriented approach. Problem-solving
                                    is in our nature. So when design adjustments
                                    are needed, we welcome customer input, step
                                    up to the plate and work co-creatively
                                    towards an optimal solution. We are flexible
                                    and passionate about the lighting business,
                                    and it shows.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* <div className="row g-0 border rounded overflow-hidden flex-md-row mb-4 shadow-sm h-md-250 position-relative">
                            <div className="col p-4 d-flex flex-column position-static">
                                <h3 className="mb-2">Our Mission</h3>
                                <p className="mb-auto">
                                    To earn your trust every day through agile
                                    and responsive customer service, as your
                                    preferred source for innovative, high
                                    performance fixtures and custom lighting
                                    solutions.
                                </p>
                            </div>
                        </div> */}

                    <div className="row align-items-md-stretch ">
                        <div className="col-md">
                            <div className="h-100 p-5 text-white bg-dark bg-gradient border shadow-lg rounded-3">
                                <h2>Our Mission</h2>
                                <p className="mb-0">
                                    To earn your trust every day through agile
                                    and responsive customer service, as your
                                    preferred source for innovative, high
                                    performance fixtures and custom lighting
                                    solutions
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
